import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";

export interface AlertModel {
  serasaObj;
}

@Component({
  selector: 'app-crednet',
  templateUrl: './crednet.component.html',
  styleUrls: ['./crednet.component.scss']
})
export class CrednetComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {

  serasaObj = null;

  constructor(dialogService: DialogService) {
    super(dialogService);
  }

  ngOnInit() {
    // serasaObj is BusinessInformationDto from /api/serasa/report/{cnpj}
  }

  closeModal() {
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/serasa/component/serasa/crednet/crednet.component.ts